import styled from 'styled-components'

export const StyledMask = styled.div`
  img{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`
